module.exports = __webpack_public_path__ + "static/img/img2.2fc9ba3.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/img2.png
// module id = gEhE
// module chunks = 1